import { eventChannel } from 'redux-saga'
import { isFunction } from 'lodash-es'

class EventChannelProxy {
  constructor(cancelFunc) {
    this.cancelled = false
    this.cancelFunc = cancelFunc
    this.eventChannel = eventChannel((emitter) => {
      this.emitter = emitter

      return this.cancel
    })
  }

  setCancelFunc(cancelFunc) {
    this.cancelFunc = cancelFunc
  }

  cancel() {
    if (isFunction(this.cancelFunc)) {
      this.cancelFunc()
    }

    delete this.cancelFunc
    this.cancelled = true
  }

  getEmitter(eventType) {
    return (...args) => {
      if (!this.cancelled) {
        if (eventType) {
          this.emitter({ eventType, args })
        } else {
          this.emitter({ args })
        }
      }
    }
  }

  getEventChannel() {
    return this.eventChannel
  }
}

export default EventChannelProxy
